import { get, prefix } from './base';

//自动开通应用权限并配置用户应用权限
export function enterApp(params) {
  return get(prefix + 'platform/enterApp', params);
}

// 获取当前登陆人及企业实名认证状态
export function getCertifyInfo(params) {
  return get(prefix + 'esign/getCertifyInfo', params);
}

export function getAgreementDetails(params) {
  return get(prefix + 'etcwx/v2/agreementRecord/getAgreementDetails', params);
}
